export default __webpack_public_path__ + "7c5975c415d8b580018217e2cbf47118.obj";